// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5KS8G","centerText":"styles_centerText__UKRaG","centerText__main":"styles_centerText__main__FvKaA","centerText__sub":"styles_centerText__sub__8rRUi"};